exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.change-history-preview .change-history-group td[data-v-17b2c8d0] {\n    background: #f3f3f4;\n    font-weight: 600;\n    border-top: 2px solid #d9dde0;\n}\n.change-history-preview .change-history-group-field[data-v-17b2c8d0] {\n    padding-left: 24px;\n}\n", ""]);

// exports
